import { fetch } from '../fetch';

/**
 * Import a JMermaid MXP file.
 *
 * @param file The file to convert (see
 * https://developer.mozilla.org/en-US/docs/Web/API/File)
 *
 * @returns the parsed JSON model snapshot. Its exact shape is not read here, so
 * it is left as `unknown` and narrowed by the caller (the projects store).
 */
export function importModel(file: File): Promise<unknown> {
  const formData = new FormData();
  formData.append('file', file);
  return fetch('/api/mxp/convert', {
    method: 'POST',
    body: formData,
  }).then(response => {
    if (response.status === 200) {
      // `Response.json()` is typed `Promise<any>` by the DOM lib; keep the
      // payload opaque (`unknown`) rather than leaking `any` to callers.
      return response.json() as Promise<unknown>;
    } else {
      return Promise.reject('Could not import the given file');
    }
  });
}
